export default __webpack_public_path__ + "static/media/elias-pic.6ad505b7.jpeg";